import { render, staticRenderFns } from "./CustomBuilds.vue?vue&type=template&id=f5c6b7ae&scoped=true"
import script from "./CustomBuilds.vue?vue&type=script&lang=js"
export * from "./CustomBuilds.vue?vue&type=script&lang=js"
import style0 from "./CustomBuilds.vue?vue&type=style&index=0&id=f5c6b7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c6b7ae",
  null
  
)

export default component.exports